import { render, staticRenderFns } from "./SwitchServer.vue?vue&type=template&id=14a3e82a"
import script from "./SwitchServer.vue?vue&type=script&lang=js"
export * from "./SwitchServer.vue?vue&type=script&lang=js"
import style0 from "./SwitchServer.vue?vue&type=style&index=0&id=14a3e82a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports